/* Search_top_PC SearchBox Functionalities:
===========================================*/
SearchTop_pc_SearchBox = {
  categoryLinks: $('.search-container_pc  .category-links'),
  link_showHide: $('.show-hide_link > a'),
  btn_uncheckAll: $('.btn-uncheck-all'),
  checkBoxes: $('.checkbox-container').find('input[type="checkbox"]'),
  tagContainer: $('.tag-container'),
};

//  Search-box 'show/hide' functionality
SearchTop_pc_SearchBox.link_showHide.on('click', function(e) {
  e.preventDefault();
  SearchTop_pc_SearchBox.categoryLinks.slideToggle(500);
  if (SearchTop_pc_SearchBox.link_showHide.text() == "閉じる") {
    SearchTop_pc_SearchBox.link_showHide
      .text("詳しい条件を追加する")
      .addClass('open');
  } else {
    SearchTop_pc_SearchBox.link_showHide
      .text("閉じる")
      .removeClass('open');
  }
});

// Search-box 'checkbox' selection action
// will generate 'selected-tags'
SearchTop_pc_SearchBox.checkBoxes.each(function() {
  $(this).on('change', function() {
    var distinct_id = $(this).data('distinct-id');
    console.log(this);
    var tech_label = $(this).parent().get(0).innerText.trim();
    if ($(this).is(':checked')) {
      var dotSeparator = '<span class="dot">・</span>';
      var appendables = '<p class="group" id="' + distinct_id + '">' + '<span class="checked">' + tech_label + '</span>' + dotSeparator + '</p>';
      SearchTop_pc_SearchBox.tagContainer.append(appendables);
    } else {
      $('#'+distinct_id).remove();
    }
  });
});

// Search-box 'clear-all' functionality
SearchTop_pc_SearchBox.btn_uncheckAll.on('click', function(e) {
  SearchTop_pc_SearchBox.tagContainer.children().remove();
  $('.category-links input[type="checkbox"]:checked').prop('checked', false);
});